import React, { Fragment, useState } from "react";
import { Button, DialogActions, DialogContent, DialogTitle, FormHelperText, TextField, Typography } from "@mui/material";
import { ErrorRounded } from "@mui/icons-material";
import { Parcel } from "../../../model/parcel";
import { useTimeout } from "../../../../common/hooks/use-timeout";
import { t } from "i18next";

interface IParcelStockoutDialogScannerProps {
    getParcelByLocator: (locator: string) => Parcel | undefined;
    onItemFound: (parcel: Parcel) => void;
    onCancel: () => void;
}

export const ParcelStockoutScanner = (props: IParcelStockoutDialogScannerProps) => {
    return <Fragment>
        <DialogTitle>
            {t("components.parcel.markAsStockout.scanner.title")}
        </DialogTitle>
        <DialogContent sx={{ width: "550px" }}>
            <Typography>
                {t("components.parcel.markAsStockout.scanner.description")}
            </Typography>
            <ScannerInputField getParcelByLocator={props.getParcelByLocator} onItemFound={props.onItemFound} />
        </DialogContent>
        <DialogActions>
            <Button variant={"outlined"} onClick={props.onCancel}>
                {t("components.parcel.markAsStockout.scanner.action.cancel")}
            </Button>
        </DialogActions>
    </Fragment>;
};

const ScannerInputField = (
    { getParcelByLocator, onItemFound }: {
        getParcelByLocator: (locator: string) => Parcel | undefined;
        onItemFound: (parce: Parcel) => void;
    }) => {
    const [value, setValue] = useState("");
    const [lastScanNotFound, setLastScanNotFound] = useState(false);

    const handleKeyUp = (key: string) => {
        if (key === "Enter") {
            const item = getParcelByLocator(value);
            if (item) {
                onItemFound(item);
            } else {
                setLastScanNotFound(true);
                setValue("");
            }

        }
    };

    useTimeout(() => setLastScanNotFound(false), 2000, lastScanNotFound);

    return <div className={"parcel-scanner"}>
        <TextField autoFocus value={value}
                   className={"parcel-scanner__input"}
                   sx={{ width: "100%" }}
                   placeholder={t("components.parcel.markAsStockout.scanner.placeholder")}
                   onChange={event => setValue(event.target.value)}
                   onKeyUp={event => handleKeyUp(event.key)} />
        {lastScanNotFound &&
            <FormHelperText error className={"parcel-scanner__error"}>
                <ErrorRounded fontSize={"small"} />
                <span>
                    {t("components.parcel.markAsStockout.scanner.error.notFound")}
                </span>
            </FormHelperText>}
    </div>;
};
